module.exports = __webpack_public_path__ + "static/media/feed_inActive.6eb3dbb1.png";